import axios from "axios";
import { Markup } from "interweave";
import { Link } from "react-router-dom";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import noImage from "../../../../../assets/images/settings/no-image.png";
import PriceTag from "../../../../../assets/images/tagPrice.PNG";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import "./AdminGreetingsView.css";
import Nodata from "../../../../../assets/Icon/Nodata.png";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import useVideoHandleWithCompress from "../../../../../CustomHooks/useVideoHandleWithCompress";
import MediaUploadProgressBar from "../../../../../Screen/MediaUploadProgressBar";


const AdminGreetingsRegisteredList = (props) => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);

  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'promoVideos', videoDelKey);



  const [loading, setloading] = useState(true);
  const [greetingRegistration, setGreetingRegistration] = useState({});
  const [forwardingLoading, setForwardingLoading] = useState(false);


  useEffect(() => {
    getGreetingRegistration();
  }, []);

  const getGreetingRegistration = () => {

    const id = props.match.params.id

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get("/api/admin/greetings_registration/show/"+ id).then((res) => {
        if (res.status === 200) {
          setGreetingRegistration(res.data.results);
        } else {
          swal("error", "Data base Error", "error");
        }
        setloading(false);
      });
    });


  };

  const handleForwardToStar = () => {
    const id = props.match.params.id;
    setForwardingLoading(true);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/greetings_registration/forward_to_star/${id}`).then((res) => {
        if (res.status === 200) {
          swal("Success", "Greeting forwarded to star successfully", "success");
          getGreetingRegistration();
        } else {
          swal("error", "Failed to forward greeting", "error");
        }
        setForwardingLoading(false);
      }).catch((err) => {
        swal("error", err.response?.data?.message || "An error occurred", "error");
        setForwardingLoading(false);
      });
    });
  };

  const handleVideoChange = (file) => {
    setVideoDelKey(videoKey);
    setVideo('');
    setVideo(file[0]);
  };

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          {Object.keys(greetingRegistration).length != 0 ? (
            <>
              <div className="row mx-2">
                <div className="col-md-7 mb-3">
                  <div className="card card-bg p-4">
                    {/* Header with Purpose */}
                    <div className="mb-4 pb-3 border-bottom border-warning">
                      <h2 className="text-warning fw-bold mb-1" style={{ fontSize: '28px' }}>
                        <i className="fas fa-gift me-2"></i>
                        {greetingRegistration.purpose?.charAt(0).toUpperCase() + greetingRegistration.purpose?.slice(1)}
                      </h2>
                      <p className="text-light small mb-0">
                        <i className="fas fa-user me-1"></i>From: {greetingRegistration.name}
                      </p>
                    </div>

                    {/* Request Metadata */}
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="text-warning small fw-bold d-block mb-1">
                            <i className="fas fa-calendar-alt me-1"></i>Request Date
                          </label>
                          <p className="text-white mb-0">
                            {moment(greetingRegistration.request_time).format('MMMM DD, YYYY')}
                          </p>
                          <small className="text-light">
                            {moment(greetingRegistration.request_time).format('hh:mm A')}
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="text-warning small fw-bold d-block mb-1">
                            <i className="fas fa-clock me-1"></i>Requested At
                          </label>
                          <p className="text-white mb-0">
                            {moment(greetingRegistration.created_at).format('MMMM DD, YYYY - hh:mm A')}
                          </p>
                          <small className="text-light">
                            {moment(greetingRegistration.created_at).fromNow()}
                          </small>
                        </div>
                      </div>
                    </div>

                    {/* Greeting Context */}
                    {greetingRegistration.greeting_context && (
                      <div className="mb-4 p-3 bg-dark rounded border border-secondary">
                        <label className="text-warning small fw-bold d-block mb-2">
                          <i className="fas fa-align-left me-1"></i>Greeting Context
                        </label>
                        <p className="text-white mb-0">
                          {greetingRegistration.greeting_context}
                        </p>
                      </div>
                    )}

                    {/* Recipient Name */}
                    {greetingRegistration.name && (
                      <div className="mb-4 p-3 bg-dark rounded border border-warning">
                        <label className="text-warning small fw-bold d-block mb-2">
                          <i className="fas fa-user me-1"></i>Person Name
                        </label>
                        <p className="text-white mb-0">
                          {greetingRegistration.name}
                        </p>
                      </div>
                    )}

                    {/* Additional Message */}
                    {greetingRegistration.additional_message && (
                      <div className="mb-4 p-3 bg-dark rounded border border-info">
                        <label className="text-info small fw-bold d-block mb-2">
                          <i className="fas fa-comment me-1"></i>Message
                        </label>
                        <p className="text-white mb-0">
                          {greetingRegistration.additional_message}
                        </p>
                      </div>
                    )}

                    {/* Forward to Star Button */}
                    <div className="mt-4 pt-3 border-top border-warning">
                      {greetingRegistration.forwarded_to_star === 1 ? (
                        <div className="alert alert-success d-flex align-items-center rounded-3" role="alert">
                          <i className="fas fa-check-circle me-2 fs-5"></i>
                          <div>
                            <strong>Status:</strong> Forwarded to Star
                            <br />
                            <small>This greeting has been successfully forwarded to the star</small>
                          </div>
                        </div>
                      ) : (
                        <button
                          className="btn btn-outline-warning fw-bold py-2 px-4 w-100 d-flex align-items-center justify-content-center"
                          onClick={handleForwardToStar}
                          disabled={forwardingLoading}
                          style={{
                            borderWidth: '2px',
                            fontSize: '16px',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          {forwardingLoading ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-2"></i>
                              Forwarding...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-paper-plane me-2"></i>
                              Forward to Star
                            </>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-5 mb-3">
                  <div className="card card-bg p-4" style={{ borderTop: '3px solid #FFC107' }}>
                    {/* User Profile Section */}
                    <div className="text-center mb-4">
                      <div className="position-relative d-inline-block mb-3">
                        <div style={{
                          width: '120px',
                          height: '120px',
                          borderRadius: '50%',
                          border: '3px solid #FFC107',
                          padding: '3px',
                          backgroundColor: '#1a1a1a',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          overflow: 'hidden'
                        }}>
                          {greetingRegistration.user?.image ? (
                            <img src={greetingRegistration.user?.image} alt={greetingRegistration.user?.first_name} width={120} style={{
                              borderRadius: '50%',
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%'
                            }}/>
                          ) : (
                            <img src={noImage} alt="No Image" width={120} style={{
                              borderRadius: '50%',
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%'
                            }}/>
                          )}
                        </div>
                        <span className="badge bg-warning text-dark position-absolute bottom-0 end-0" style={{ fontSize: '12px', padding: '6px 10px' }}>
                          <i className="fas fa-user me-1"></i>Requester
                        </span>
                      </div>
                      <h4 className="text-white fw-bold mt-3 mb-1">
                        {greetingRegistration.user?.first_name} {greetingRegistration.user?.last_name}
                      </h4>
                      <p className="text-light small mb-2">
                        <i className="fas fa-phone me-1"></i>{greetingRegistration.user?.phone}
                      </p>
                      <p className="text-warning small fw-bold">
                        <i className="fas fa-user-circle me-1"></i>{greetingRegistration.user?.user_type}
                      </p>
                    </div>

                    {/* Status Information */}
                    <hr className="border-warning" />
                    <div className="mt-3">
                      <div className="mb-3">
                        <label className="text-warning small fw-bold d-block mb-2">
                          <i className="fas fa-info-circle me-1"></i>Status
                        </label>
                        <div className="d-flex gap-2 flex-wrap">
                          <span className={`badge ${greetingRegistration.status === 1 ? 'bg-success' : 'bg-secondary'} px-3 py-2`}>
                            {greetingRegistration.status === 1 ? 'Active' : 'Inactive'}
                          </span>
                          <span className={`badge ${greetingRegistration.forwarded_to_star === 1 ? 'bg-warning text-dark' : 'bg-secondary'} px-3 py-2`}>
                            {greetingRegistration.forwarded_to_star === 1 ? 'Forwarded' : 'Not Forwarded'}
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="text-info small fw-bold d-block mb-2">
                          <i className="fas fa-share-alt me-1"></i>Shared Status
                        </label>
                        <span className={`badge ${greetingRegistration.is_shared === 1 ? 'bg-info px-3 py-2' : 'bg-secondary px-3 py-2'}`}>
                          {greetingRegistration.is_shared === 1 ? 'This is a shared greeting' : 'Not shared'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="my-4 row mx-2">
                <div className="col-md-7 mb-3">

                <div className="text-light border border-warning rounded-3 d-flex justify-content-center align-items-center p-3 mb-4" style={{ backgroundColor: 'rgba(255, 193, 7, 0.05)', borderWidth: '2px' }}>
                  <div className="faTrophy">
                    <i className="fa-solid fa-video" style={{ fontSize: '24px', color: '#FFC107' }}></i>
                  </div>
                 <h4 className="mx-3 text-warning p-2 mb-0 fw-bold">Upload Greeting Video</h4>
              </div>
              <div className="card card-bg mb-3 p-4">
                <div className="container-lg">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <form
                        className="p-0"
                        onSubmit={null}
                        id="input_form"
                        encType="multipart/form-data"
                      >
                        <div className="form-group mb-4">
                          <label
                            htmlFor="video_url"
                            className="form-label text-warning fw-bold mb-3 d-block"
                            style={{ fontSize: '16px' }}
                          >
                            <i className="fas fa-film me-2"></i>Greeting Video
                          </label>

                          <div className="position-relative">
                            <div className="card card-bg m-0 p-0 overflow-hidden" style={{ borderWidth: '2px', borderColor: '#FFC107' }}>
                              {videoUrl && video ? (
                                <div className="position-relative bg-dark">
                                  <ReactPlayer
                                    url={videoUrl}
                                    controls
                                    playing={false}
                                    volume={1}
                                    width="100%"
                                    height="300px"
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger position-absolute top-2 end-2"
                                    onClick={null}
                                    style={{ zIndex: 10 }}
                                  >
                                    <i className="fas fa-trash-alt me-1"></i>Remove
                                  </button>
                                </div>
                              ) : (
                                <div className="bg-dark p-5 text-center" style={{ minHeight: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <ReactPlayer
                                    url={videoCdnUrl + null}
                                    controls
                                    playing={false}
                                    volume={1}
                                    width="100%"
                                    height="300px"
                                  />
                                </div>
                              )}
                              <div className="p-3 border-top border-warning bg-dark">
                                <label htmlFor="file_input" className="cursor-pointer d-block text-center">
                                  <input
                                    id="file_input"
                                    type="file"
                                    className="d-none"
                                    accept="video/mp4,video/webm,video/ogg,video/quicktime"
                                    placeholder="Enter title here...!"
                                    onChange={(e) => handleVideoChange(e.target.files)}
                                    name="video_url"
                                  />
                                  <div className="text-warning fw-bold">
                                    <i className="fas fa-cloud-upload-alt me-2" style={{ fontSize: '20px' }}></i>
                                    Click to upload or drag & drop
                                  </div>
                                  <small className="text-light d-block mt-2">Supported formats: MP4, WebM, Ogg</small>
                                </label>
                              </div>
                            </div>
                            {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                          </div>
                        </div>


                        {/* Update Submit */}
                        <div className="mt-4 pt-3 border-top border-warning">
                          <button
                            className="btn btn-warning fw-bold py-2 px-5 w-100"
                            type="submit"
                            disabled={loading}
                            style={{
                              fontSize: '16px',
                              borderRadius: '6px',
                              transition: 'all 0.3s ease',
                              backgroundColor: loading ? '#6c757d' : '#FFC107',
                              borderColor: loading ? '#6c757d' : '#FFC107'
                            }}
                          >
                            {loading ? (
                              <>
                                <i className="fas fa-spinner fa-spin me-2"></i>Updating...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-save me-2"></i>Update Video
                              </>
                            )}
                          </button>
                        </div>
                        {/* Update Submit End */}
                      </form>
                    </div>
                  </div>
                </div>
              </div>


                </div>

                <div className="col-md-5">
                  <div className="row">
                    <div className="col-md-12">
                      {/* Pricing and Payment Card */}
                      <div className="card card-bg p-4 mb-3" style={{ borderTop: '3px solid #28a745' }}>
                        <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom border-success">
                          <h5 className="text-success fw-bold mb-0">
                            <i className="fas fa-credit-card me-2"></i>Payment Details
                          </h5>
                          <span className={`badge ${greetingRegistration?.payment_status == 1 ? 'bg-success' : 'bg-warning text-dark'} px-3 py-2`}>
                            {greetingRegistration?.payment_status == 1 ? 'Paid' : 'Pending'}
                          </span>
                        </div>

                        {/* Amount Section */}
                        <div className="mb-4 p-3 bg-dark rounded border border-success">
                          <label className="text-light small d-block mb-2">
                            <i className="fas fa-money-bill-wave me-1"></i>Total Amount
                          </label>
                          <h3 className="text-success fw-bold mb-0">
                            ${greetingRegistration?.amount || greetingRegistration?.greeting?.cost}
                          </h3>
                        </div>

                        {/* Payment Method */}
                        <div className="mb-3">
                          <label className="text-warning small fw-bold d-block mb-2">
                            <i className="fas fa-wallet me-1"></i>Payment Method
                          </label>
                          <div className="p-3 bg-dark rounded border border-warning">
                            <p className="text-white mb-0">
                              {greetingRegistration?.payment_method?.replace('-', ' ') || 'Not specified'}
                            </p>
                          </div>
                        </div>

                        {/* Payment Status Details */}
                        <div className="mb-3">
                          <label className="text-info small fw-bold d-block mb-2">
                            <i className="fas fa-check-double me-1"></i>Payment Status
                          </label>
                          <div className="p-3 bg-dark rounded border border-info">
                            <div className="d-flex align-items-center">
                              {greetingRegistration?.payment_status === 1 ? (
                                <>
                                  <i className="fas fa-check-circle text-success me-2" style={{ fontSize: '20px' }}></i>
                                  <span className="text-success fw-bold">Payment Completed</span>
                                </>
                              ) : (
                                <>
                                  <i className="fas fa-clock text-warning me-2" style={{ fontSize: '20px' }}></i>
                                  <span className="text-warning fw-bold">Awaiting Payment</span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Share Amount if available */}
                        {greetingRegistration?.share_amount && (
                          <div className="mb-3 p-3 bg-dark rounded border border-info">
                            <label className="text-info small fw-bold d-block mb-2">
                              <i className="fas fa-share-alt me-1"></i>Share Amount
                            </label>
                            <p className="text-info mb-0">${greetingRegistration?.share_amount}</p>
                          </div>
                        )}
                      </div>

                      {/* Star Information Card */}
                      <div className="card card-bg p-4" style={{ borderTop: '3px solid #17a2b8' }}>
                        <h5 className="text-info fw-bold mb-3">
                          <i className="fas fa-star me-2"></i>Star Information
                        </h5>
                        <div className="text-center mb-3">
                          <div style={{
                            width: '100px',
                            height: '100px',
                            borderRadius: '50%',
                            border: '3px solid #17a2b8',
                            padding: '3px',
                            backgroundColor: '#1a1a1a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            margin: '0 auto'
                          }}>
                            {greetingRegistration.greeting?.star?.image ? (
                              <img src={greetingRegistration.greeting?.star?.image} alt={greetingRegistration.greeting?.star?.first_name} style={{
                                borderRadius: '50%',
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%'
                              }}/>
                            ) : (
                              <img src={noImage} alt="No Image" style={{
                                borderRadius: '50%',
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%'
                              }}/>
                            )}
                          </div>
                        </div>
                        <h6 className="text-white fw-bold text-center">
                          {greetingRegistration.greeting?.star?.first_name} {greetingRegistration.greeting?.star?.last_name}
                        </h6>
                        <p className="text-light text-center small mb-0">
                          <i className="fas fa-badge-check me-1"></i>Superstar
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row justify-content-center align-items-center mx-2">
                <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                  <img src={Nodata} alt="" className=" Nodata" />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default AdminGreetingsRegisteredList;
